import { getNextMonth, getPreviousMonth } from '../utils';
export var getNextMonthByDate = date => {
  var currentMonth = parseInt(date.slice(5, 7)) - 1;
  return getNextMonth(currentMonth, parseInt(date.slice(0, 4)));
};
export var getPreviousMonthByDate = date => {
  var currentMonth = parseInt(date.slice(5, 7)) - 1;
  return getPreviousMonth(currentMonth, parseInt(date.slice(0, 4)));
};
//# sourceMappingURL=utils.js.map